module.exports = __webpack_public_path__ + "img/antes_despues_195.852b38ff.png";